<div class="layout">
  <app-sidebar-menu></app-sidebar-menu>

  <div class="main-panel">
    <header class="topbar">
      <h1>Pantalla Principal</h1>
      <div class="topbar-right">
        <app-header-notification-bell [rol]="rolSeleccionado"></app-header-notification-bell>
        <app-accessibility-toolbar></app-accessibility-toolbar>
        <app-user-session-summary></app-user-session-summary>
      </div>
    </header>
    <div class="content-breadcrumbs">
      <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
    </div>

    <app-principal-dashboard-panel [rolSeleccionado]="rolSeleccionado"></app-principal-dashboard-panel>
  </div>
</div>
